
export function ssnNumberMasking(ssn: string): string {
    let formattedSSN = "XXX-XX-" + ssn.substring(ssn.length - 0, 5);
    return formattedSSN;
  }